import { render, staticRenderFns } from "./AlertRulesUpdateNotice.vue?vue&type=template&id=c0cf4092&scoped=true&"
import script from "./AlertRulesUpdateNotice.vue?vue&type=script&lang=js&"
export * from "./AlertRulesUpdateNotice.vue?vue&type=script&lang=js&"
import style0 from "./AlertRulesUpdateNotice.vue?vue&type=style&index=0&id=c0cf4092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cf4092",
  null
  
)

export default component.exports